<mat-card class="stripe-account-card-container">
  <!-- this is the modal -->
  <!-- <p>stripe-payout-settings works!</p> -->

  <div>
    <!-- user info here -->
    <div>
      <h2>
        Account information
      </h2>
    </div>

    <div *ngIf="stripeAccountDataLoading$ | async else accountInfoMain">
      <app-spinner></app-spinner>
    </div>

    <ng-template #accountInfoMain>
      <form [formGroup]="accountDetailsForm">
        <div>
          <mat-form-field appearance="fill">
            <mat-label>First Name</mat-label>
            <input matInput type="text" placeholder="First Name" formControlName="fname" />
          </mat-form-field>
          <div *ngIf="accountDetailsForm.controls.fname.touched">
            <small *ngIf="accountDetailsForm.controls.fname.hasError('required')" class="text-danger">First Name is
              required</small>
          </div>

          <div>
            <mat-form-field>
              <input matInput type="text" class="form-control" placeholder="Last Name" formControlName="lname" />
            </mat-form-field>
            <div *ngIf="accountDetailsForm.controls.lname.touched">
              <small *ngIf="accountDetailsForm.controls.lname.hasError('required')" class="text-danger">Last Name is
                required</small>
            </div>
          </div>

          <div>
            <div class="col-12">
              <label style="font-size: 12px;opacity: 0.6;">Gender</label>
            </div>
            <div class="col-12" style="padding-bottom: 10px;">
              <mat-radio-group formControlName="gender">
                <mat-radio-button value="male">Male</mat-radio-button>
                <mat-radio-button style="padding-left:10px;" value="female">Female</mat-radio-button>
              </mat-radio-group>
              <div style="position: relative;margin-top: 8px;"
                *ngIf="accountDetailsForm.controls.bDay.touched || accountDetailsForm.controls.address.touched || accountDetailsForm.controls.email.touched">
                <small *ngIf="accountDetailsForm.controls.gender.hasError('required')" class="text-danger">Gender is
                  required</small>
              </div>
            </div>
          </div>


          <div>
            <mat-form-field appearance="fill">
              <mat-label>Choose a date</mat-label>
              <mat-datepicker #picker></mat-datepicker>
              <input matInput [matDatepicker]="picker" [value]="dateValue"
                (dateChange)="dateOfBirthDatePickerChange($event.value)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <input matInput type="email" class="form-control" placeholder="E-mail Address" formControlName="email" />
            </mat-form-field>
            <div *ngIf="accountDetailsForm.controls.email.touched">
              <small *ngIf="accountDetailsForm.controls.email.hasError('required')" class="text-danger">
                E-mail Address
                is
                required
              </small>
              <small *ngIf="accountDetailsForm.controls.email.hasError('email')" class="text-danger">
                Please Enter a
                Valid
                E-Mail
                Address
              </small>
            </div>
          </div>

          <div>
            <mat-form-field appearance="fill">
              <input matInput type="text" class="form-control" placeholder="eg. 6591067649" formControlName="phoneNum" />
              <mat-label>Phone Number</mat-label>
            </mat-form-field>
          </div>

          <div>
            <mat-form-field>
              <input matInput type="text" class="form-control" placeholder="Personal Identification"
                formControlName="p_id" [matTooltipPosition]="'above'"
                matTooltip="National Registration Identity Card (NRIC) or Foreign Identification Number (FIN)" />
            </mat-form-field>
            <div *ngIf="accountDetailsForm.controls.p_id.touched">
              <small *ngIf="accountDetailsForm.controls.p_id.hasError('required')" class="text-danger">
                Personal
                Identification
                is
                required
              </small>
              <small *ngIf="accountDetailsForm.controls.p_id.hasError('invalid')" class="text-danger">
                Please Enter a
                Valid
                Personal ID
              </small>
            </div>
          </div>

          <div>
            <mat-form-field>
              <input matInput type="text" class="form-control" placeholder="Address" formControlName="address" />
            </mat-form-field>
            <div *ngIf="accountDetailsForm.controls.address.touched">
              <small *ngIf="accountDetailsForm.controls.address.hasError('required')" class="text-danger">Address is
                required</small>
            </div>
          </div>

        </div>
      </form>
    </ng-template>
  </div>

  <div>
    <!-- bank card add and list here -->
    <div>
      <h2> Bank account(s) </h2>
    </div>
    <div>

      <div *ngIf="stripeAccountDataLoading$ | async else bankAccountDiv">
        <app-spinner></app-spinner>
      </div>

      <ng-template #bankAccountDiv>
        <mat-accordion class="">
          <!-- iterate banks -->
          <mat-expansion-panel *ngFor="let bankAccount of (bankAccounts$ | async)">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon *ngIf="bankAccount.default_for_currency">check_circle</mat-icon>
                {{ bankAccount.bank_name }}
              </mat-panel-title>
              <mat-panel-description>
                ●●●● ●●●● ●●●● {{ bankAccount.last4 }} - {{ bankAccount.currency?.toUpperCase() }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div>
              <!-- content here?
              set default?
              details? -->
              <mat-form-field class="" appearance="fill">
                <mat-label>Account Holder Name</mat-label>
                <input disabled matInput placeholder="Name" [value]="bankAccount.account_holder_name">
              </mat-form-field>
              <mat-form-field class="" appearance="fill">
                <mat-label>Routing number</mat-label>
                <input disabled matInput placeholder="Name" [value]="bankAccount.routing_number">
              </mat-form-field>

              <div>
                <div *ngIf="!bankAccount.default_for_currency">
                  <button mat-raised-button color="primary" (click)="setBankAccountAsCurrencyDefault(bankAccount.id)">
                    Set as default
                  </button>
                  <button mat-raised-button color="primary" (click)="removeBankAccount(bankAccount.id)">
                    Remove account
                  </button>
                </div>
                <!-- <button mat-raised-button color="primary">Save</button> -->
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-description>
                {{ bankDetailsForm.dirty ? 'Edit new bank account details' : 'Add a Bank Account' }}
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div>
              <form [formGroup]="bankDetailsForm">
                <input style="display: none;">
                <h4>Bank Details</h4>
                <div class="form-group">
                  <mat-form-field appearance="fill">
                    <mat-label>Account Holder Name</mat-label>
                    <input matInput placeholder="e.g John" formControlName="name">
                  </mat-form-field>

                  <div *ngIf="bankDetailsForm.controls.name.touched">
                    <small *ngIf="bankDetailsForm.controls.name.hasError('required')" class="text-danger">
                      Account Holder Name is Required
                    </small>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-12">
                    <mat-form-field appearance="fill">
                      <mat-label>Account Number</mat-label>
                      <input matInput placeholder="e.g 80792892" formControlName="accountNo">
                    </mat-form-field>

                    <div *ngIf="bankDetailsForm.controls.accountNo.touched">
                      <small *ngIf="bankDetailsForm.controls.accountNo.hasError('required')" class="text-danger">
                        Account number is required (e.g 80792892)
                      </small>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-6">
                    <mat-form-field appearance="fill">
                      <mat-label>Bank Code</mat-label>
                      <input matInput placeholder="e.g 1234" formControlName="bankcode">
                    </mat-form-field>
                    <div *ngIf="bankDetailsForm.controls.bankcode.touched">
                      <small *ngIf="bankDetailsForm.controls.bankcode.hasError('required')" class="text-danger">
                        Bank Code Required (e.g 1234)
                      </small>
                      <small
                        *ngIf="bankDetailsForm.controls.bankcode.hasError('minLength') || bankDetailsForm.controls.bankcode.hasError('maxLength')"
                        class="text-danger">
                        Invalid Bank Code: Format = XXXX
                      </small>
                      <!-- <small *ngIf="bankDetailsForm.controls.bankcode.hasError('pattern')" class="text-danger">Invalid Bank
                        Code</small> -->
                    </div>
                  </div>
                  <div class="col-6">
                    <mat-form-field appearance="fill">
                      <mat-label>Branch Code</mat-label>
                      <input matInput placeholder="e.g 456" formControlName="branchcode">
                    </mat-form-field>
                    <div *ngIf="bankDetailsForm.controls.branchcode.touched">
                      <small *ngIf="bankDetailsForm.controls.branchcode.hasError('required')" class="text-danger">
                        Branch Code Required (e.g 456)
                      </small>
                      <small
                        *ngIf="bankDetailsForm.controls.branchcode.hasError('minLength') || bankDetailsForm.controls.branchcode.hasError('maxLength')"
                        class="text-danger">
                        Invalid Branch Code: Format = XXX
                      </small>
                      <!-- <small *ngIf="bankDetailsForm.controls.branchcode.hasError('pattern')" class="text-danger">Invalid Branch
                        Code</small> -->
                    </div>
                  </div>
                </div>
                <p>By registering your account, you agree to our <a href="#tos-acceptance">Services Agreement</a> and
                  the <a target="_blank" href="https://stripe.com/connect-account/legal">Stripe Connected Account
                    Agreement</a>.</p>
              </form>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

      </ng-template>
    </div>
  </div>

  <div class="terms-area">
    <!-- disable on accept? -->
    <div *ngIf="stripeAccountDataLoading$ | async else termsAndConditionsDiv">
      <app-spinner></app-spinner>
    </div>

    <ng-template #termsAndConditionsDiv>
      <!-- <h5 class="terms-label" (click)="showTermsModal()">
        Accept terms and conditions
      </h5> -->
      <div *ngIf="stripeAccountData$ | async as stripeAccountData">
        <button *ngIf="stripeAccountId && showTermsButton(stripeAccountData)"
          mat-button color="warn" (click)="showTermsModal()">
          Accept terms and conditions
        </button>
      </div>
    </ng-template>
  </div>

  <div class="card-actions">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="disableSave">Save</button>
  </div>

</mat-card>